var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.274 24.236v-9.183h-3.001v-3.63h3V8.214a4 4 0 014-4h3.418v2.994h-2.9a1 1 0 00-1 1v3.213h3.461l-.332 3.63h-3.129v9.185h4.644a3 3 0 003-3v-18a3 3 0 00-3-3h-18a3 3 0 00-3 3v18a3 3 0 003 3h9.839z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgFacebook;